<div *ngIf="!isAvatar" class="text-center">
  <img
    (click)="showImage()"
    [height]="height"
    src="{{ host + image }}"
    [style]="'height: ' + height + 'px;min-width:32px'"
    class="cursor img-fluid img-thumbnail"
  />
</div>
<div *ngIf="isAvatar" class="media">
  <div class="media-aside align-self-center">
    <span class="rounded-circle" style="width: 32px; height: 32px"
      ><span class="avatar-img"
        ><img src="{{ host + image }}" alt="avatar" class="img-fluid"
      /></span>
    </span>
  </div>
  <div class="media-body"></div>
</div>
